
export default function TelemedProviders() {
  return (
    <>
      <section className="telemed-providers-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="telemed-provider-head">
                <h2 className="heading center-heading"><label>A Global Solution </label> <span className="gradiant-color">for Healthcare Providers</span></h2>
                <p className="sub-heading">Serving healthcare professionals worldwide, our telemedicine platform addresses the growing need for accessible and efficient digital healthcare. Whether for routine check-ups or critical consultations, Mobility Infotech ensures streamlined processes across continents, covering nations like the USA, UK, Canada, Brazil, India, and more.</p>
              </div>
            </div>

            <div className="col-lg-11">
              <div className="telemed-provider-img">
                <img src="/assets/home/telemed-providers.webp" alt="telemed" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
